import pm from './pm'
import purchase from './purchase'
import store from './store'
import print from './print'
import order from './order'
import sales from './sales'
import statement from './statement'
import statistics from './statistics'
import cenPurchase from './cen-purchase'
import payment from './payment'
import account from './account'
import screen from './screen'
import secondhand from './secondhand'
import area from './secondhand/area'
import report from './report'
import information from './information'
import pushOrder from './push'
import imp from './order/imp'
import inputInvoice from './inputInvoice'
import outputInvoice from './outputInvoice'
import salesContracts from './salesContracts'

export default {
  pm,
  purchase,
  order,
  store,
  print,
  sales,
  statement,
  statistics,
  cenPurchase,
  payment,
  account,
  screen,
  secondhand,
  area,
  report,
  information,
  pushOrder,
  inputInvoice,
  outputInvoice,
  salesContracts
}



// WEBPACK FOOTER //
// ./src/api/apis/self/index.js